const systemCohortActions = {
  FETCH_SYSTEM_COHORT: 'FETCH_SYSTEM_COHORT',
  SHOW_SYSTEM_COHORT: 'SHOW_SYSTEM_COHORT',
  SHOW_SYSTEM_COHORT_ERROR: 'SHOW_SYSTEM_COHORT_ERROR',
  CLOSE_SYSTEM_COHORT: 'CLOSE_SYSTEM_COHORT',
};

export default systemCohortActions;
